import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { TimeSeriesPivotTableDataService } from '@backoffice-frontend/controlling/domain';
import { ActionButtonModule } from '@clean-code/shared/components/ui-action-button';
import dayjs from 'dayjs';
import { tap } from 'rxjs';
import { PivotTableService } from '../../data/pivot-table.service';

@Component({
  selector: 'feature-pivot-table-duplicate-cell-data-dialog',
  imports: [
    CommonModule,
    MatTableModule,
    MatCheckboxModule,
    ActionButtonModule,
    MatDialogModule,
  ],
  templateUrl: './duplicate-cell-data-dialog.component.html',
  styleUrls: ['./duplicate-cell-data-dialog.component.scss'],
})
export class DuplicateCellDataDialogComponent {
  public dialogParams = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<DuplicateCellDataDialogComponent>);
  public service = inject(TimeSeriesPivotTableDataService);
  protected tableService = inject(PivotTableService);

  items: any;
  title: string =
    this.dialogParams.position.columnSymbol +
    ', ' +
    dayjs(this.dialogParams.position.rowDate).format('YYYY-MM-DD');

  dataSource$ = this.service
    .getAllDuplicatedData$(
      this.dialogParams.position.rowDate,
      this.dialogParams.position.columnSymbol,
    )
    .pipe(
      tap((data) => {
        this.items = data;
      }),
    );

  selectedCheckbox: number | null = null;

  onCheckboxChange(id: number) {
    if (this.selectedCheckbox === id) {
      this.selectedCheckbox = null;
    } else {
      this.selectedCheckbox = id;
    }
  }

  deleteItems(): void {
    const n = this.items.filter(
      (item: any) => item.id !== this.selectedCheckbox,
    );
    const nMapped = n.map((item: any) => item.id);
    this.service
      .deleteDuplicateData$(nMapped)
      .pipe(
        tap(() => {
          this.tableService.setRefreshTable(true);
          this.dialogRef.close(true);
        }),
      )
      .subscribe();
  }

  displayedColumns = [
    'select',
    'settlementPrice',
    'openPrice',
    'highPrice',
    'lowPrice',
    'volume',
  ];
}
